import { observer } from 'mobx-react';
import { HomeStore } from '../stores/HomeStore';
import { useAuthContext } from './AuthProvider';
import { LabSidePanel } from './side-panel/LabSidePanel';
import { UserSidePanel } from './side-panel/UserSidePanel';

export const View = {
  tinkerboxFiles: 'tinkerboxFiles',
  sharedFiles: 'sharedFiles'
} as const;
export type ViewType = typeof View[keyof typeof View];

export interface SidePanelProps {
  store: HomeStore;
  className?: string;
  setOpen: (visible: boolean) => void;
  open: boolean;
  tinkerBoxConnection: HomeStore['tinkerBoxConnection'];
}

export const SidePanel = observer((props: SidePanelProps) => {
  const { user } = useAuthContext();

  const canReadLab = user?.permissions.includes('lab_read') ?? false;

  if (canReadLab) {
    return <LabSidePanel {...props} />;
  }

  return <UserSidePanel {...props} />;
});
